export class TagLanguage {
  constructor(name, language) {
    this.name = name;
    this.language = language;
  }
}
